import React, { useEffect, useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { formatDate } from '../../../../common/SharedFunctions';
import { FileSelectDialog } from '../../../../common/SharedComponents';
import { InsuranceFileType } from '../InsuranceConstants';
import { v4 as uuidv4 } from 'uuid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';

const FileOperationsModal = ({
    options = {
        parentId: 0,
        insuranceTypeName: '',
        files: [],
        isOpen: false,
    },
    onSubmit,
    onCancel,
}) => {
    const styles = {
        buttonMarginRight: { marginRight: '10px' },
        buttonContainer: {
            textAlign: 'right',
            borderTop: '2px solid silver',
            padding: '10px 10px',
        },
        fileUpload: {
            display: 'inline-block',
            padding: '10px',
            cursor: 'pointer',
        },
        addButton: {
            width: '70px',
            position: 'absolute',
            right: '20px',
            paddingTop: '15px',
        },
    };

    const [fileSelectOptions, set_fileSelectOptions] = useState({
        isOpen: false,
        maxFiles: 10,
        isReplace: false,
        typeName: '',
    });

    const [files, set_files] = useState([]);

    useEffect(() => {
        if (!options) {
            options = {
                parentId: 0,
                insuranceTypeName: '',
                files: [],
                isOpen: false,
            };
            return;
        }

        const newFiles = options.files.map((f) => {
            return { ...f };
        });
        set_files(newFiles);
    }, [options]);

    const onAddClick = () => {
        const selectOptions = {
            guid: uuidv4(),
            isOpen: true,
            maxFiles: 10,
            isReplace: false,
            fileTypeName: options?.insuranceTypeName,
        };
        set_fileSelectOptions(selectOptions);
    };

    const onFileSelectSubmit = async (id, filesToAdd) => {
        set_fileSelectOptions({ ...fileSelectOptions, isOpen: false });

        if (!filesToAdd || filesToAdd.length === 0) {
            return;
        }

        const newFileArray = files ?? [];
        filesToAdd.forEach((f) => {
            const newFile = {
                guid: uuidv4(),
                fileTypeId: InsuranceFileType.Policy,
                fileName: f.name,
                file: f,
                deleted: false,
                typeName: 'Policy',
                tempFileName: 'temp',
            };
            newFileArray.push(newFile);
        });
        set_files(newFileArray);
    };

    const onFileSelectCancel = () => {
        set_fileSelectOptions({ ...fileSelectOptions, isOpen: false });
    };

    const _onSubmit = async () => {
        onSubmit && onSubmit(options.parentId, files);
    };

    const _onCancel = () => {
        onCancel && onCancel();
    };

    const setDeleted = (guid, checked) => {
        const target = files.find((f) => f.guid === guid);
        if (target) {
            if (target.file) {
                set_files(files.filter((f) => f.guid !== guid));
            } else {
                target.deleted = checked;
                set_files([...files]);
            }
        }
    };

    if (!(options.isOpen ?? false)) {
        return '';
    }

    return (
        <>
            <Dialog
                maxWidth='sm'
                open={true}
                onClose={() => _onCancel()}
                aria-labelledby='form-dialog-title'
            >
                <DialogContent>
                    <div className='modal-container'>
                        <div className='modal-backdrop'></div>
                        <div
                            className='modal'
                            tabIndex='-1'
                            role='dialog'
                            style={{ width: '700px' }}
                        >
                            <div
                                className='modal-dialog'
                                role='document'
                            >
                                <div>
                                    <div
                                        className='page-header'
                                        role='banner'
                                    >
                                        <h1>File Add, Download & Delete</h1>
                                        <span style={styles.addButton}>
                                            <button
                                                type='button'
                                                className='button hollow'
                                                style={{
                                                    backgroundColor: 'white',
                                                }}
                                                data-dismiss='modal'
                                                onClick={onAddClick}
                                            >
                                                <span
                                                    aria-hidden='true'
                                                    title='Add new Files'
                                                >
                                                    Add
                                                </span>
                                            </button>
                                        </span>

                                        <button
                                            type='button'
                                            className='close'
                                            data-dismiss='modal'
                                            aria-label='Close'
                                            onClick={() => _onCancel()}
                                        >
                                            <span aria-hidden='true'>&times;</span>
                                        </button>
                                    </div>
                                    <div>
                                        <div style={{ padding: '10px 10px' }}>
                                            Type: <span style={{ fontWeight: 'bold' }}>{options.insuranceTypeName}</span>
                                        </div>
                                        <div style={{ padding: '10px 10px' }}>
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <td>File Name</td>
                                                        <td
                                                            style={{
                                                                width: '70px',
                                                            }}
                                                        >
                                                            Type
                                                        </td>
                                                        <td
                                                            style={{
                                                                width: '100px',
                                                            }}
                                                        >
                                                            Uploaded
                                                        </td>
                                                        <td
                                                            style={{
                                                                textAlign: 'center',
                                                                width: '50px',
                                                            }}
                                                        ></td>
                                                        <td
                                                            style={{
                                                                textAlign: 'center',
                                                                width: '80px',
                                                            }}
                                                        >
                                                            Delete?
                                                        </td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {!files ||
                                                        (files.length === 0 && (
                                                            <tr>
                                                                <td
                                                                    colSpan='5'
                                                                    style={{
                                                                        padding: '50px',
                                                                        textAlign: 'center',
                                                                    }}
                                                                >
                                                                    No Files have been uploaded...
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    {files?.length > 0 &&
                                                        files.map((f) => (
                                                            <tr key={f.guid}>
                                                                <td
                                                                    style={{
                                                                        height: '60px',
                                                                        textOverflow: 'ellipsis',
                                                                        maxWidth: '350px',
                                                                    }}
                                                                >
                                                                    {!f.url && <div>{f.fileName}</div>}
                                                                    {f.url && (
                                                                        <a
                                                                            href={f.url}
                                                                            title='Click to download'
                                                                        >
                                                                            {f.fileName}
                                                                        </a>
                                                                    )}
                                                                    <div
                                                                        style={{
                                                                            color: 'darkred',
                                                                            fontStyle: 'italic',
                                                                        }}
                                                                    >
                                                                        {f.deleted
                                                                            ? 'Deletion pending save...'
                                                                            : f.tempFileName
                                                                              ? 'Temporary file awaiting save...'
                                                                              : ''}
                                                                    </div>
                                                                </td>
                                                                <td>{f.typeName}</td>
                                                                <td>{formatDate(f.uploadDate)}</td>
                                                                <td
                                                                    style={{
                                                                        textAlign: 'center',
                                                                    }}
                                                                >
                                                                    {f.url && (
                                                                        <a
                                                                            href={f.url}
                                                                            title='Click to download'
                                                                        >
                                                                            <FontAwesomeIcon
                                                                                icon={faDownload}
                                                                                style={styles.iconYes}
                                                                            />
                                                                        </a>
                                                                    )}
                                                                </td>
                                                                <td
                                                                    style={{
                                                                        textAlign: 'center',
                                                                        verticalAlign: 'bottom',
                                                                    }}
                                                                >
                                                                    <input
                                                                        type='checkbox'
                                                                        checked={f.deleted}
                                                                        onChange={(event) =>
                                                                            setDeleted(f.guid, event.target.checked)
                                                                        }
                                                                    ></input>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div
                                        className='button-footer'
                                        style={styles.buttonContainer}
                                    >
                                        <button
                                            style={styles.buttonMarginRight}
                                            type='submit'
                                            className='button primary'
                                            onClick={_onSubmit}
                                        >
                                            Submit
                                        </button>
                                        <button
                                            type='button'
                                            className='button hollow'
                                            data-dismiss='modal'
                                            onClick={() => _onCancel()}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </DialogContent>
            </Dialog>
            <FileSelectDialog
                options={fileSelectOptions}
                onSubmit={onFileSelectSubmit}
                onCancel={onFileSelectCancel}
            />
        </>
    );
};

export default FileOperationsModal;
